import * as React from 'react';

import {
    LEAD_RESEARCH_AGENT,
    EMAIL_SEQUENCE_AGENT,
    SALES_OBJECTION_AGENT,
    SALES_PROCESS_AGENT,
} from './helpers';
import type {AgentKey} from './helpers';

type UseTeamAiOpenAgentParams = {
    canUseAgents: boolean | number | null | undefined;
    onAgentSelected: (agentKey: AgentKey) => void;
};

export function useTeamAiOpenAgent(params: UseTeamAiOpenAgentParams) {
    const {canUseAgents, onAgentSelected} = params;

    // Listen for custom event to open a specific agent and open the sidebar
    React.useEffect(() => {
        const handleOpenAgent = (event: CustomEvent) => {
            const agentKey = event.detail && event.detail.agentKey;
            if (canUseAgents && agentKey) {
                // Validate the agent key
                let validatedAgentKey: AgentKey | null | undefined = null;
                switch (agentKey) {
                    case LEAD_RESEARCH_AGENT:
                        validatedAgentKey = LEAD_RESEARCH_AGENT;
                        break;
                    case EMAIL_SEQUENCE_AGENT:
                        validatedAgentKey = EMAIL_SEQUENCE_AGENT;
                        break;
                    case SALES_OBJECTION_AGENT:
                        validatedAgentKey = SALES_OBJECTION_AGENT;
                        break;
                    case SALES_PROCESS_AGENT:
                        validatedAgentKey = SALES_PROCESS_AGENT;
                        break;
                    default:
                        break;
                }

                if (validatedAgentKey) {
                    onAgentSelected(validatedAgentKey);
                }
            }
        };

        // @ts-expect-error
        window.addEventListener('teamAiOpenAgent', handleOpenAgent);

        return () => {
            // @ts-expect-error
            window.removeEventListener('teamAiOpenAgent', handleOpenAgent);
        };
    }, [canUseAgents, onAgentSelected]);
}
